<template>

  <div>
  <el-dialog title="添加账户信息" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
    :close-on-press-escape="false">
    <el-form size="small" ref="form" :model="form">
      <el-form-item label="选择用户"  :label-width="formLabelWidth" :rules="[{ required: true, message: ' ' }]" prop="user_id">
        <el-row>
          <el-button @click="addClick" icon="el-icon-plus">选择会员</el-button>
          <div v-if="form.user_id!=''" class="img">
            <img :src="user_info.avatarUrl" width="100" height="100" />
          </div>
          <div>
            <p v-if="user_info.user_id">{{user_info.nickName}}【ID:{{user_info.user_id}}】</p>
            <el-link :underline="false" disabled>选择后不可更改</el-link>
          </div>
        </el-row>
      </el-form-item>
      <el-form-item label="开户姓名" :label-width="formLabelWidth" :rules="[{ required: true, message: ' ' }]" prop="truename">
         <el-input v-model="form.truename"  placeholder="" class="max-w460"></el-input>
         <div class="gray">设置后不可变更</div>
      </el-form-item>
      <el-form-item label="身份证号" :label-width="formLabelWidth" :rules="[{ required: true, message: ' ' }]" prop="id_card">
         <el-input v-model="form.id_card"  placeholder="" class="max-w460"></el-input>
         <div class="gray">设置后不可变更</div>
      </el-form-item>
      <el-form-item label="银行"  :label-width="formLabelWidth" :rules="[{ required: true, message: ' ' }]" prop="bank_code_id">
        <el-select v-model="form.bank_code_id" placeholder="请选择银行">
          <el-option :label="item.name" v-for="(item, index) in bankList" :key="index" :value="item.bank_code_id"></el-option>
        </el-select>
      </el-form-item>
      
      <el-form-item label="卡号" :label-width="formLabelWidth"  :rules="[{ required: true, message: ' ' }]" prop="account">
        <el-input v-model="form.account" class="max-w460"></el-input>
      </el-form-item>
      
      <el-form-item label="手机号" :label-width="formLabelWidth" :rules="[{ required: true, message: ' ' }]" prop="mobile">
         <el-input v-model="form.mobile"  placeholder="" class="max-w460"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="add" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
    <!--添加-->
    <GetUser :is_open="open_user" @close="closeDialogFunc"></GetUser>
  </div>
</template>

<script>
  import FinanceApi from '@/api/finance.js';
  import DataApi from '@/api/data.js';
  import GetUser from '@/components/user/GetUser.vue';
  export default {
    components: {
      GetUser
    },
    data() {
      return {
        /*是否上传图片*/
        isupload: false,
        open_user: false,
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        loading: false,
        dialogVisible: false,
        /*form表单数据*/
        user_info: {},
        form: {
          user_id:'',
          id_card: '',
          mobile:'',
          account: '',
          truename: '',
          bank_name: '',
        },
        bankList:[]
      };
    },
    props: ['open_add'],
    created() {
      this.getBank();
      this.dialogVisible = this.open_add;
    },
    methods: {
      getBank(){
        let self = this;
        DataApi.getBankList({}, true)
          .then(data => {
            if (data.code == 1) {
              self.bankList = data.data.bankList
            }
          })
          .catch(error => {
          });
      },
        /*上传*/
      openUpload(e) {
        this.isupload = true;
      },
      /*获取图片*/
      returnImgsFunc(e) {
        if (e != null && e.length > 0) {
          this.form.image_url = e[0].file_path;
          this.form.image_id = e[0].file_id;
        }
        this.isupload = false;
      },
      
      /*修改用户*/
      add() {
        let self = this;

        let params = self.form;
        console.log(params)
        
        
         self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
              FinanceApi.add(params, true)
              .then(data => {
                self.loading = false;
                if (data.code == 1) {
                  self.$message({
                    message: '恭喜你，操作成功',
                    type: 'success'
                  });
                  self.dialogFormVisible(true);
                }
              })
              .catch(error => {
                self.loading = false;
              });
          }
        });
        
      },
      showMessage(msg='信息不能为空'){
        this.$message({
            message: msg,
            type: 'warning'
          });
      },
      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      },

      /*打开弹出层*/
      addClick() {
        this.open_user = true;
      },

      /*关闭获取用户弹窗*/
      closeDialogFunc(e) {
        if (e.type != 'error') {
          this.user_info = e.params[0];
          this.form.user_id = e.params[0].user_id;
        }
        this.open_user = false;
      },


    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/finance/bank/dialog/Add.vue